import React, { Fragment } from 'react';
import Table from "../../components/table/table-component";
import "./full-report-top-words.css";


const FullReportTopWordsComponent = (
  {
    topWordsPaginated,
    columns,
    page,
    loading,
    changePage,
    searchChange,
    searchValue,
    reportUrl
  }
) => {
  return (
    <Fragment>
      {
        topWordsPaginated ?
          <Fragment>
            <Table
              columns={columns}
              data={topWordsPaginated}
              page={page}
              loading={loading}
              changePage={changePage}
              searchChange={searchChange}
              searchValue={searchValue}
              reportUrl={reportUrl}
            />
          </Fragment>
          :
          null
      }
    </Fragment>
  )
};


export default FullReportTopWordsComponent;


// WEBPACK FOOTER //
// ./src/modules/full-report-top-words/full-report-top-words-component.js